export const cacheKey = "/engagement/whatsapp/messaging_services" as const;
